import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDiffusionCommunicationProgramById, fetchCourseCommunicationProgramById, fetchCourseAvailableCommunicationProgramById } from 'app/actions/CommunicationProgramActions';

import { getCommunicationProgramDiffusion, getIsLoadingCommunicationProgramDiffusion, getCommunicationProgramCourse, getCommunicationProgramCourseAvailable, getIsLoadingCommunicationProgramCourse, getIsLoadingCommunicationProgramCourseAvailable} from 'app/reducers';
import moment from 'moment';
import isEmpty from 'app/utils/IsEmpty';

export default function EditDiffusionContainer(props){

    let communicationProgramDiffusion = useSelector(getCommunicationProgramDiffusion);
    let isLoading = useSelector(getIsLoadingCommunicationProgramDiffusion);
    let isLoadingCourse = useSelector(getIsLoadingCommunicationProgramCourse);
    let isLoadingCourseAvailable = useSelector(getIsLoadingCommunicationProgramCourseAvailable);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isEmpty(communicationProgramDiffusion)) fetchCommunicationProgramDiffusionAction();
        //if (isEmpty(communicationProgramCourse)) fetchCommunicationProgramCourseAction();
        //if (isEmpty(communicationProgramCourseAvailable)) fetchCommunicationProgramCourseAvailableAction();
    }, []);

    const fetchCommunicationProgramDiffusionAction = () => dispatch(fetchDiffusionCommunicationProgramById(props.filterData.idCommunicationProgram))
    
    //const communicationProgramsCourse = (!isLoadingCourse && !isLoadingCourseAvailable) ? communicationProgramCourse.concat(communicationProgramCourseAvailable) : [];
    const communicationProgramsDiffusion = communicationProgramDiffusion.map((param, i) => {
        const activeKey = { activeKey: { isActive: false, key: i } };
        let startDate = moment(param.diffusionStartDate).format('DD/MM/YYYY');
        let startEndDate = moment(param.diffusionEndDate).format('DD/MM/YYYY');
        const vigency = {
            vigency: [moment(startDate, 'DD/MM/YYYY'), moment(startEndDate,'DD/MM/YYYY')]
        };
        //param['mockData'] = communicationProgramsCourse;
        Object.assign(param, activeKey, vigency)
        return param;
    })

    
    /*communicationProgramsCourse.forEach(item => {
        item['key'] = item.idCourse;
        item['disabled'] = false; 
        item['nameWithCode']= item.courseCode +' - '+ item.courseName;
    });*/

    return (props.children({ communicationProgramsDiffusion, isLoading, isLoadingCourse, isLoadingCourseAvailable}));
}